// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__y9sLN","footer-crescendo":"styles_footer-crescendo__4DZ4U","icon":"styles_icon__8OXxN"};